import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { useLongPress } from "use-long-press";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const PenButton: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    isPenEnabled,
    isZoomed,
    ZwibblerUsePenTool,
    ZwibblerEnableReadOnlyMode,
    toolConfig,
  } = rootStore.zwibblerStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);
  const { isMobileMediaQuery, setColorModalOpen, isColorModalOpen } = rootStore.responsiveStore;
  const [disabledClick, setDisabledClick] = useState(false);

  const handleClick = () => {
    if (isPenEnabled) ZwibblerEnableReadOnlyMode();
    else ZwibblerUsePenTool();
  };
  const handleLongClick = async () => {
    setColorModalOpen(true);
  };
  const callback = React.useCallback(() => {
    handleLongClick();
  }, []);

  const bind = useLongPress(callback, {
    onStart: () => setDisabledClick(false),
    onCancel: () => setDisabledClick(true),
    threshold: 500,
  });

  return (
    <>
      <Button
        {...bind()}
        id="penna"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 transparentButton toolbarButton",
          isPenEnabled
            ? `${theme!.toolbarActiveIconColor}`
            : `${theme!.toolbarIconColor}`
        )}
        disabled={isZoomed}
        color=""
        onClick={() => (disabledClick ? handleClick() : null)}
        style={{ position: "relative" }}
      >
        <i className="fas fa-pencil-alt iconToolbarButton"></i>
        <h6 className="textToolbarButton mb-0">{t("toolbar_pen_button")}</h6>
        {isMobileMediaQuery && (
          <div
            className="penColor"
            style={{ backgroundColor: toolConfig.color }}
          ></div>
        )}{" "}
      </Button>
    </>
  );
};

export default observer(PenButton);
